import React, { useEffect, useState, useRef } from 'react';
import './selection.scss';
import { ReactComponent as ArrowDown } from 'elements/appSelect/icons/arrowdown.svg';
import { activeDigestEmailItemAtom, activeUpcomingEventEmailItemAtom, newContentEmailItemAtom } from 'showMessageMenuAtom';
import { useAtom } from 'jotai';
import { ReactComponent as XIcon } from 'assets/img/x-filled.svg';

const SelectionDropDown = (
    {
        options,
        defaultOption,
        toggleOption,
        optionsType,
        isDisabled,
        arrowDownstyles
    }:
        {
            options: Array<any>
            defaultOption: any
            toggleOption?: any
            optionsType?: string
            isDisabled?: boolean
            arrowDownstyles?: string
        }
) => {
    const [selectedOption, setSelectedOption] = useState<any>(defaultOption);
    const [isOptionsVisible, setIsOptionsVisible] = useState(false);
    const [, setActiveDigestEmailItem] = useAtom(activeDigestEmailItemAtom);
    const [, setActiveUpcomingEventEmailItem] = useAtom(activeUpcomingEventEmailItemAtom);
    const [, setNewContentEmailItem] = useAtom(newContentEmailItemAtom);
    const [showXIcon, setShowXIcon] = useState(false);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleOptionClick = (option: React.SetStateAction<string>) => {
        if (optionsType === 'upcomingEvents') {
            const upComimgEventEmailOptions: any = ['Daily', 'Weekly', 'Every 14-days', 'Monthly', 'Never'];
            if (upComimgEventEmailOptions.includes(option)) {
                setActiveUpcomingEventEmailItem(option);
            }
        }

        if (optionsType === 'digestEmail') {
            const digestEmailOptions: any = ['Daily', 'Weekly', 'Every 14-days', 'Monthly', 'Never'];
            if (digestEmailOptions.includes(option)) {
                setActiveDigestEmailItem(option);
            }
        }

        if (optionsType === 'contentEmail') {
            const newContentEmailOptions: any = ['Daily', 'Weekly', 'Every 14-days', 'Monthly', 'Never'];
            if (newContentEmailOptions.includes(option)) {
                setNewContentEmailItem(option);
            }
        }

        if (optionsType === 'remove_resource_access') {
            setShowXIcon(true)
        }

        setSelectedOption(option);
        setIsOptionsVisible(false);
        toggleOption(option)
    };

    useEffect(() => {
        const closeOptionsDiv = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOptionsVisible(false);
            }
        };

        document.addEventListener('mousedown', closeOptionsDiv);

        return () => {
            document.removeEventListener('mousedown', closeOptionsDiv);
        };
    }, []);

    const toggleOptions = () => {
        if (optionsType === 'remove_resource_access') {
            if (isDisabled || showXIcon) {
                return
            }
        }
        setIsOptionsVisible(!isOptionsVisible);
    };

    useEffect(() => {
        setSelectedOption(defaultOption);
    }, [defaultOption])

    return (
        <div className="notifictions-select-wrapper" ref={dropdownRef}>
            <div className={`notifictions-select ${(isDisabled || (showXIcon && !isDisabled)) ? 'notifictions-select-no-hover' : ''}`} onClick={toggleOptions}>
                <span className='notifictions-select-span'>
                    {selectedOption}
                </span>

                {
                    (showXIcon && !isDisabled) ?
                        <span className='notifictions-x-icon' onClick={() => {
                            setShowXIcon(false)
                            setIsOptionsVisible(!isOptionsVisible)
                        }}
                        >
                            <XIcon />
                        </span>
                        :
                        <>
                            {
                                ((isDisabled === false) || (isDisabled === undefined)) ?
                                    <span className={`${arrowDownstyles ? arrowDownstyles : ''} notifictions-icon `}>
                                        <ArrowDown />
                                    </span>
                                    :
                                    <></>
                            }
                        </>
                }
            </div>
            {isOptionsVisible && (
                <div className="notifictions-select-options" id='notifictions-select-options'>
                    {options.map((option) => (
                        <div
                            key={option}
                            className="notifictions-select-option"
                            onClick={() => handleOptionClick(option)}
                        >
                            <span className="notifictions-select-option-span">
                            {option}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SelectionDropDown;
